import expImg1 from '../../Assets/Images/exp-img1.svg';
import expImg2 from '../../Assets/Images/exp-img2.svg';
import expImg3 from '../../Assets/Images/exp-img3.svg';
import i18n from 'src/i18n';

export let expiredConstants = {
  GE2CConstants: {
    pageHeading: i18n.t('GE2CExpiredHeader'),
    headingHelperText: i18n.t('GE2CExpiredHelperText'),
    renewBtn: {
      desktop: {
        text: i18n.t('renewText'),
        link: '#'
      },
      tablet: {
        text: i18n.t('renewText'),
        link: '#'
      }
    },
    tagline: {
      taglinePart1: i18n.t('taglineText'),
      mainText: i18n.t('taglineSubtext'),
    },
    cardListHeading: i18n.t('continueSubsQuestion'),
  },

  C2CConstants: {
    pageHeading: i18n.t('C2CExpiredHeader'),
    headingHelperText: i18n.t('C2CExpiredHelperText'),
    renewBtn: {
      desktop: {
        text: i18n.t('renewText'),
        link: '#'
      },
      tablet: {
        text: i18n.t('renewText'),
        link: '#'
      }
    },
    tagline: {
      taglinePart1: i18n.t('taglineText'),
      mainText: i18n.t('taglineSubtext'),
    },
    cardListHeading: i18n.t('continueSubsQuestion'),
  },

  mixedConstants: {
    pageHeading: i18n.t('mixedExpiredHeader'),
    headingHelperText: i18n.t('mixedExpiredHelperText'),
    renewBtn: {
      desktop: {
        text: i18n.t('renewText'),
        link: '#'
      },
      tablet: {
        text: i18n.t('renewText'),
        link: '#'
      }
    },
    tagline: {
      taglinePart1: i18n.t('taglineText'),
      mainText: i18n.t('taglineSubtext'),
    },
    cardListHeading: i18n.t('continueSubsQuestion'),
    logout: {
      text: i18n.t('logOutTxt'),
    },
  },

  unauthConstants: {
    pageHeading: i18n.t('unAuthHeader'),
    renewBtn: {
      desktop: {
        text: i18n.t('interestedTxt'),
        link: '#'
      },
      tablet: {
        text: i18n.t('interestedTxt'),
        link: '#'
      }
    },
    tagline: {
      taglinePart1: i18n.t('taglineSubtext'),
      mainText: i18n.t('taglineSubtext'),
    },
    cardListHeading: i18n.t('continueSubsQuestion'),
  },
}

// Common cards data
export let cardList = [
  {
    img: expImg1,
    heading: i18n.t('cardHeader1'),
    infoText: i18n.t('cardInfo1'),
  },
  {
    img: expImg3,
    heading: i18n.t('cardHeader3'),
    infoText: i18n.t('cardInfo3'),
  },
]

i18n.on('languageChanged', function() {
  updateTranslations();
});

function updateTranslations () {
  expiredConstants = {
    GE2CConstants: {
      pageHeading: i18n.t('GE2CExpiredHeader'),
      headingHelperText: i18n.t('GE2CExpiredHelperText'),
      renewBtn: {
        desktop: {
          text: i18n.t('renewText'),
          link: '#'
        },
        tablet: {
          text: i18n.t('renewText'),
          link: '#'
        }
      },
      tagline: {
        taglinePart1: i18n.t('taglineText'),
        mainText: i18n.t('taglineSubtext'),
      },
      cardListHeading: i18n.t('continueSubsQuestion'),
    },
  
    C2CConstants: {
      pageHeading: i18n.t('C2CExpiredHeader'),
      headingHelperText: i18n.t('C2CExpiredHelperText'),
      renewBtn: {
        desktop: {
          text: i18n.t('renewText'),
          link: '#'
        },
        tablet: {
          text: i18n.t('renewText'),
          link: '#'
        }
      },
      tagline: {
        taglinePart1: i18n.t('taglineText'),
        mainText: i18n.t('taglineSubtext'),
      },
      cardListHeading: i18n.t('continueSubsQuestion'),
    },
  
    mixedConstants: {
      pageHeading: i18n.t('mixedExpiredHeader'),
      headingHelperText: i18n.t('mixedExpiredHelperText'),
      renewBtn: {
        desktop: {
          text: i18n.t('renewText'),
          link: '#'
        },
        tablet: {
          text: i18n.t('renewText'),
          link: '#'
        }
      },
      tagline: {
        taglinePart1: i18n.t('taglineText'),
        mainText: i18n.t('taglineSubtext'),
      },
      cardListHeading: i18n.t('continueSubsQuestion'),
      logout: {
        text: i18n.t('logOutTxt'),
      },
    },
  
    unauthConstants: {
      pageHeading: i18n.t('unAuthHeader'),
      renewBtn: {
        desktop: {
          text: i18n.t('interestedTxt'),
          link: '#'
        },
        tablet: {
          text: i18n.t('interestedTxt'),
          link: '#'
        }
      },
      tagline: {
        taglinePart1: i18n.t('taglineSubtext'),
        mainText: i18n.t('taglineSubtext'),
      },
      cardListHeading: i18n.t('continueSubsQuestion'),
    },
  };
  cardList = [
    {
      img: expImg1,
      heading: i18n.t('cardHeader1'),
      infoText: i18n.t('cardInfo1'),
    },
    {
      img: expImg2,
      heading: i18n.t('cardHeader2'),
      infoText: i18n.t('cardInfo2'),
    },
    {
      img: expImg3,
      heading: i18n.t('cardHeader3'),
      infoText: i18n.t('cardInfo3'),
    },
  ];
}
